import React, { useEffect } from "react";
import { FaGoogle } from "react-icons/fa";
import GoogleIcon from "../../assets/images/google.svg";
import rev1 from "../../assets/images/nmd-img.jpg";

import "./ReviewsSection.css";

const ReviewsSection = () => {
  const googleReviewLink =
    "https://www.google.com/search?q=NMD+Infotech+Pune+reviews";

  // ⭐ SCROLL ANIMATION EFFECT (same as WhoWeAre)
  useEffect(() => {
    const elements = document.querySelectorAll(".zoom-scroll");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="review-section">

      <h3 className="review-subtitle zoom-scroll">
        Clients Have Given Us A Five Star Rating On Google
      </h3>

      <h2 className="review-title zoom-scroll">
        Glowing Customer Reviews
      </h2>

      <div className="review-row">

        {/* CARD 1 */}
        {/* <div className="glass-card zoom-scroll">
          <img src={GoogleIcon} className="google-corner-icon" alt="google" />

          <div className="profile-img">
            <img src={rev1} alt="client" />
          </div>

          <h3>NMD InfoTech</h3>
          <p className="stars">⭐⭐⭐⭐⭐ 5.0</p>
          <p>Based on 4 reviews powered by Google</p>

          <a href={googleReviewLink} target="_blank" rel="noopener noreferrer">
            <button className="g-btn google-btn">
              <FaGoogle className="google-icon" />
              Review Us On Google
            </button>
          </a>
        </div> */}

        {/* CARD 2 */}
        <div className="glass-card zoom-scroll">
          <img src={GoogleIcon} className="google-corner-icon" alt="google" />

          <div className="profile-img blue">PS</div>
          <h3>PS Gaikwad</h3>
          <p className="stars">⭐⭐⭐⭐⭐ 5.0</p>
          <p>Best IT service with very transparent support.</p>
        </div>

        {/* CARD 3 */}
        <div className="glass-card zoom-scroll">
          <img src={GoogleIcon} className="google-corner-icon" alt="google" />

          <div className="profile-img purple">JP</div>
          <h3>JP Shroff</h3>
          <p className="stars">⭐⭐⭐⭐⭐ 5.0</p>
          <p>Best business IT consulting with amazing insights.</p>
        </div>

        {/* CARD 4 */}
        <div className="glass-card zoom-scroll">
          <img src={GoogleIcon} className="google-corner-icon" alt="google" />

          <div className="profile-img green">P</div>
          <h3>Prasad Mudrankit</h3>
          <p className="stars">⭐⭐⭐⭐⭐ 5.0</p>
          <p>Best Consulting & IT Services Provider in Pune.</p>
        </div>

      </div>

      <div className="review-btn-wrapper zoom-scroll">
        <a href={googleReviewLink} target="_blank" rel="noopener noreferrer">
          <button className="check-btn">Check All Reviews</button>
        </a>
      </div>
    </section>
  );
};

export default ReviewsSection;
